import axios from '../../axios'
import { parseScanValue } from 'shared/util/ticketCode'

function listFrom(data, keys) {
  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key]
  }
  return []
}

export const scannerApi = {
  sendOtp: (body) => axios.post('v1/otp/send', body),
  loginOtp: (body) => axios.post('v1/scanner-user/login-otp', body),
  logout: () => axios.post('v1/auth/logout'),
  eventsAll: (params) => axios.get('v1/scanner-user/events/all', { params }),
  eventsPast: (params) => axios.get('v1/scanner-user/events/past', { params }),
  scanOrder: (eventId, body) => axios.post(`v1/ticket/organiser/scan/order/${eventId}`, body),
  scanTicket: (eventId, body) => axios.post(`v1/ticket/organiser/scan/${eventId}`, body),
  reports: (eventId) => axios.get(`v1/scanner-user/event/reports/${eventId}`),
  eventReport: (eventId) => axios.get(`v1/scanner-user/event/event-report/${eventId}`),
  registeredUsers: (eventId, params) => axios.get(`v1/scanner-user/event/registered-users/${eventId}`, { params }),
  resendEmail: (eventId, orderId) => axios.get(`v1/scanner-user/event/resend-email/${eventId}/${orderId}`),
  coupons: (eventId, params) => axios.get(`v1/coupon/organiser/${eventId}`, { params }),
  createCoupon: (eventId, body) => axios.post(`v1/coupon/organiser/${eventId}`, body),
  editCoupon: (eventId, body) => axios.put(`v1/coupon/organiser/${eventId}`, body),
  deleteCoupon: (couponId, eventId) => axios.delete(`v1/coupon/organiser/${couponId}/${eventId}`),
  placeOrder: (eventId, body) => axios.post(`v1/order/organiser/place/${eventId}`, body),
  plans: (eventId) => axios.get('v1/event/plans/all', { params: { iEventId: eventId } }),
  staffList: (params) => axios.get('v1/scanner-user/organiser/all', { params }),
  staffGet: (id) => axios.get(`v1/scanner-user/organiser/${id}`),
  staffCreate: (body) => axios.post('v1/scanner-user/organiser/', body),
  staffUpdate: (id, body) => axios.put(`v1/scanner-user/organiser/${id}`, body),
  staffDelete: (id) => axios.delete(`v1/scanner-user/organiser/${id}`),
  permissions: () => axios.get('v1/permissions/'),
  roles: () => axios.get('v1/roles/')
}

export function extractList(payload, keys) {
  const data = payload?.data?.data || payload?.data || payload
  return listFrom(data, keys)
}

export function extractData(payload) {
  return payload?.data?.data || payload?.data || payload
}

export function extractArray(payload, keys = []) {
  const data = extractData(payload)
  if (Array.isArray(data)) return data
  return extractList(payload, keys)
}

export function apiMessage(error, fallback = 'Something went wrong') {
  return error?.response?.data?.sMessage || error?.response?.data?.message || error?.message || fallback
}

export function scanErrorPayload(error) {
  const body = error?.response?.data
  if (!body || typeof body !== 'object') return null
  const inner = body.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) return { ...body, ...inner }
  return body
}

export function scanByCode(eventId, rawCode, nAdmitCount = 1) {
  const parsed = parseScanValue(rawCode)
  if (!parsed?.value) {
    const err = new Error('Invalid ticket code')
    err.response = { status: 400, data: { sMessage: 'Invalid ticket code' } }
    return Promise.reject(err)
  }
  const count = Math.max(1, Number(nAdmitCount) || 1)
  if (parsed.type === 'mongo') {
    return scannerApi.scanTicket(eventId, { iTicketId: parsed.value, nAdmitCount: count })
  }
  return scannerApi.scanOrder(eventId, { iOrderId: parsed.value, nAdmitCount: count })
}
